<div class="tt-c-rating tt-c-rating--actionable">
  <tt-button v-for="n in 5"
             type="icon" 
             @click.stop="ratingSelected(n)"
             @mouseenter="ratingEnter(n)"
             @mouseleave="ratingLeave()"
             class="tt-c-rating__star"
             :aria-label="$msg('ratingStars.selectToRate', [n], n)"
             :key="n">
    <tt-icon v-if="rating < n" name="star--empty" class="tt-c-rating__icon" :size="starSize"></tt-icon>
    <tt-icon v-if="rating >= n" name="star--full" class="tt-c-rating__icon" :size="starSize"></tt-icon>
  </tt-button>
</div>



// WEBPACK FOOTER //
// ./src/components/rating/actionable-rating-stars.html